import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import BusinessList from '../BusinessList/BusinessList.js';
import SearchBar from '../SearchBar/SearchBar.js';
import Yelp from '../../until/Yelp';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      businesses: []
    };
    this.searchYelp = this.searchYelp.bind(this);
  }
  searchYelp(term, location, sortBy) {
    Yelp.search(term, location, sortBy).then((businesses) => {
      // Only update state if businesses is not undefined
      if (businesses) {
        this.setState({ businesses: businesses });
      } else {
        console.log("No businesses found or API error.");
        this.setState({ businesses: [] }); // Reset to an empty array instead of undefined
      }
    });
  }

  render() {
    return (
      <div className="App">
        <div style={{
          backgroundColor: '#ffcc00',
          color: '#000',
          padding: '10px',
          textAlign: 'center',
          fontSize: '0.9rem',
          fontWeight: 'bold'
        }}>
          ⚠️ Portfolio Note: To see live results, please 
          <a 
            href="https://cors-anywhere.herokuapp.com/corsdemo" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ textDecoration: 'underline', marginLeft: '5px', color: '#000' }}
          >
            click here and request temporary access 
          </a> 
           to the CORS proxy.
        </div>
        <h1>ravenous</h1>
          <SearchBar searchYelp={this.searchYelp} />
          {this.state.isLoading 
            ? <p style={{color: 'white', textAlign: 'center'}}>Searching Yelp...</p> 
            : <BusinessList businesses={this.state.businesses} />
          } 
      </div>
    );
  }
};

export default App;
